import _ from 'lodash';
import { RootState } from '../../model/rootReducer';

export const createLoadingSelector = (actions: string[]) => (state: RootState) =>
  // returns true only when all actions is not loading
  _(actions)
    .some((action) => _.get(state, `loading.${action}`));
